import { render, staticRenderFns } from "./lubricators.vue?vue&type=template&id=45544cbe&"
import script from "./lubricators.vue?vue&type=script&lang=js&"
export * from "./lubricators.vue?vue&type=script&lang=js&"
import style0 from "./lubricators.vue?vue&type=style&index=0&id=45544cbe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports